module.exports = __webpack_public_path__ + "img/miceala-meintjies.eaf60c09.png";